import React from 'react';

const Requirements = () => {
  const requirements = [
    {
      text: "Ser mayor de 18 años y presentar una licencia de conducir vigente del país o extranjera."
    },
    {
      text: "Presentar identificación válida",
      highlight: "(Residencia o Pasaporte)"
    },
    {
      text: "Informar la",
      highlight: "fecha y hora",
      text2: "de entrega y devolución del vehículo."
    },
    {
      text: "En caso de entrega en aeropuertos u otras zonas especiales, podría aplicar un",
      highlight: "cargo",
      text2: "adicional, el cual será informado previamente."
    },
    {
      text: "Entregar el vehículo con la misma cantidad de combustible con la que fue recibido."
    },
    {
      text: "Hacer un depósito de",
      highlight: "100 US$",
      text2: "para separar las fechas."
    }
  ];

  const cancellationPolicy = {
    text: "EN CASO DE CANCELACIÓN, EL DEPÓSITO DE RESERVA NO SERÁ REEMBOLSABLE. AL CONFIRMAR UNA RESERVA, EL VEHÍCULO QUEDA BLOQUEADO PARA ESA FECHA, LO QUE IMPLICA RECHAZAR OTRAS SOLICITUDES DE CLIENTES INTERESADOS."
  };

  return (
    <section className="py-20 md:py-32 bg-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-700/20 border border-yellow-600/30 px-4 py-2 mb-6">
            <span className="text-yellow-600 text-sm font-medium">INFORMACIÓN IMPORTANTE</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Requisitos para Reservar un Vehículo
          </h2>
        </div>

        {/* Requirements Grid */}
        <div className="bg-zinc-900 border border-white/10 p-8 md:p-12 mb-8">
          <ul className="space-y-6">
            {requirements.map((req, index) => (
              <li key={index} className="flex items-start gap-4">
                <div className="w-2 h-2 bg-yellow-700 rounded-full flex-shrink-0 mt-2"></div>
                <p className="text-white/90 text-lg leading-relaxed">
                  {req.text}
                  {req.highlight && (
                    <span className="text-yellow-600 font-semibold"> {req.highlight}</span>
                  )}
                  {req.text2 && ` ${req.text2}`}
                </p>
              </li>
            ))}
          </ul>
        </div>

        {/* Cancellation Policy */}
        <div className="bg-yellow-700/10 border-2 border-yellow-700/30 p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="text-yellow-600 font-bold text-xl flex-shrink-0">AVISO:</div>
            <p className="text-white/90 text-base leading-relaxed">
              {cancellationPolicy.text}
            </p>
          </div>
        </div>

        {/* Contact Info */}
        <div className="text-center mt-12">
          <p className="text-white/70 mb-6">
            ¿Tienes dudas sobre los requisitos? Contáctanos
          </p>
          <a
            href="https://wa.me/18099640099?text=Tengo%20dudas%20sobre%20los%20requisitos%20para%20alquilar"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-yellow-700 text-white px-8 py-4 font-semibold text-lg hover:bg-yellow-800 transition-all duration-300"
          >
            Consultar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default Requirements;
